// extracted by mini-css-extract-plugin
module.exports = {"infoSwitch":"_2UR3Qu0wu0feEtDtvZpaPp","switchButton":"_3WUg6TChvoLWchduZlc4vQ","active":"_29fgo3YKWqODoeJS96M1VN"};